import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Page } from '../models/page-wrapper.model';
import { Contract } from './contract.model';
import { ContractDetails } from './contractDetails.model';
import { ContractAttachment } from './contract-attachment.model';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private apiUrl = `${environment.restApiUrl}contracts`;

  constructor(private http: HttpClient) {}

  createSalesContract(contract: Partial<Contract> | FormData): Observable<Contract> {
    return this.http.post<Contract>(this.apiUrl + '/create/sales', contract);
  }

  createFinanceContract(contract: FormData): Observable<Contract> {
    return this.http.post<Contract>(this.apiUrl + '/create/finance', contract);
  }

  searchContracts(params: HttpParams): Observable<Page<Contract>> {
    return this.http.get<Page<Contract>>(this.apiUrl + '/search', { params });
  }

  getContractById(id: number): Observable<Contract> {
    return this.http.get<Contract>(`${this.apiUrl}/${id}`);
  }

  updateContractHeader(
    id: number,
    contract: Partial<Contract>
  ): Observable<Contract> {
    return this.http.post<Contract>(`${this.apiUrl}/header/update/${id}`, contract);
  }

  updateContractDetails(
    id: number,
    contract: Partial<ContractDetails>
  ): Observable<ContractDetails> {
    return this.http.post<ContractDetails>(`${this.apiUrl}/${id}/details/`, contract);
  }

  updateAllContractDetails(
    id: number,
    details: ContractDetails[]
  ): Observable<ContractDetails[]> {
    return this.http.post<ContractDetails[]>(`${this.apiUrl}/${id}/details/update`, details);
  }

  deleteContract(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateContractStatus(
    id: number,
    workflowStatusId: number,
    updatedByUserId: number
  ): Observable<Contract> {
    const params = new HttpParams()
      .set('workflowStatusId', workflowStatusId.toString())
      .set('updatedByUserId', updatedByUserId.toString());
    return this.http.patch<Contract>(`${this.apiUrl}/${id}/status`, null, {
      params,
    });
  }
  getAttachmentViewUrl(
    contractId: number,
    attachmentId: number
  ): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(
      `${this.apiUrl}/${contractId}/attachments/${attachmentId}/view-url`
    );
  }

  uploadAttachments(contractId: number, attachments: ContractAttachment[]): Observable<ContractAttachment[]> {
    return this.http.post<ContractAttachment[]>(`${this.apiUrl}/${contractId}/attachments`, attachments);
  }

  searchContractDetails(params: HttpParams): Observable<Page<ContractDetails>> {
    return this.http.get<Page<ContractDetails>>(this.apiUrl + '/details/search', { params });
  }
}
